import { useEffect, useState, type FormEvent } from 'react';
import { api } from '@/lib/api';
import type { FamilyNote } from '@shared/types';
import { NoteIcon } from './Icons';

export function NotesSection({ placeId }: { placeId: number }) {
  const [notes, setNotes] = useState<FamilyNote[] | null>(null);
  const [draft, setDraft] = useState('');
  const [author, setAuthor] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api.get<{ notes: FamilyNote[] }>(`/places/${placeId}/notes`).then((res) => setNotes(res.notes));
  }, [placeId]);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!draft.trim()) return;
    setSubmitting(true);
    try {
      await api.post(`/places/${placeId}/notes`, { note: draft.trim(), author: author.trim() || undefined });
      const res = await api.get<{ notes: FamilyNote[] }>(`/places/${placeId}/notes`);
      setNotes(res.notes);
      setDraft('');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="card">
      <h2>
        <NoteIcon style={{ verticalAlign: 'middle', marginRight: 6 }} />
        Family Notes
      </h2>
      {notes && notes.length === 0 && <p style={{ color: 'var(--color-ink-muted)', fontSize: 14 }}>No notes yet.</p>}
      {notes?.map((n) => (
        <div key={n.id} className="note-block">
          {n.author && <div className="note-label">{n.author}</div>}
          {n.note}
        </div>
      ))}
      <form onSubmit={handleSubmit} style={{ marginTop: 16 }}>
        <div className="field">
          <label htmlFor={`note-${placeId}`}>Add a note</label>
          <textarea
            id={`note-${placeId}`}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Great takeout. Avoid Friday at 7."
          />
        </div>
        <div className="field">
          <label htmlFor={`author-${placeId}`}>Your name (optional)</label>
          <input id={`author-${placeId}`} type="text" value={author} onChange={(e) => setAuthor(e.target.value)} />
        </div>
        <button type="submit" className="btn btn-secondary" disabled={submitting || !draft.trim()}>
          Save Note
        </button>
      </form>
    </div>
  );
}
